/**
 * 协议管理接口
 */
export default {
  // 协议管理-协议维护-协议维护列表
  cnnc_qryAgreementInfoByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementInfoByPage'
  },
  // 协议管理-协议维护-查看审批情况
  cnnc_qryAgreementOperationRecordList: {
    // mock: true,
    control: 'dyc/saas/common/agr/qryAgreementOperationRecordList'
  },
  // 协议管理-协议维护-协议维护列表-下拉供应商列表
  common_qryDropDwonList: {
    // mock: true,
    control: '/dyc/saas/supplier/qrySupplierInfoAccessListPage'
  },
  // 协议管理-协议维护-协议维护列表-删除操作
  cnnc_deleteAgreementInfo: {
    // mock: true,
    control: 'dyc/zone/agreement/deleteAgreementInfo'
  },
  // 协议管理-协议维护-协议主体详情
  cnnc_qryAgreementSubjectDetails: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementSubjectDetails'
  },
  // 协议管理-协议维护-协议主体详情（免登录）
  cnnc_noauthQryAgreementSubjectDetails: {
    // mock: true,
    control: 'dyc/zone/agreement/noauth/qryAgreementSubjectDetails'
  },
  // 协议管理-协议维护-协议明细分页查询
  cnnc_qryAgreementSkuByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementSkuByPage'
  },
  // 公用应用-通用参数列表查询
  common_qryParamConfigList: {
    // mock: true,
    control: 'dyc/config/cfc/qryParamConfigList    '
  },
  // 协议管理-协议维护-供应商列表
  common_qryDropDwonListExceptAccess: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryDropDwonList'
  },
  // 协议管理-根据供应商ID获取联系人
  common_getEnterpriseContactPageList: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/getEnterpriseContactPageList'
  },
  // 协议管理-协议维护-供应商列表-新
  common_qryContractOrgList: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryContractOrgList'
  },
  // 协议管理-协议维护-协议主体创建
  cnnc_createAgreementSubjectInfo: {
    // mock: true,
    control: 'dyc/zone/agreement/createAgreementSubjectInfo'
  },
  // 协议管理-协议维护-协议主体创建-应用范围
  cnnc_qryAgreementInfoScope: {
    // mock: true,
    control: 'dyc/saas/common/agr/qryAgreementInfoScope'
  },
  // 协议管理-协议维护-协议主体创建-协议编号
  cnnc_createAgreementCode: {
    // mock: true,
    control: 'dyc/zone/agreement/createAgreementCode'
  },
  // 协议管理-批量导入应用范围
  cnnc_batchImportAgreementScope: {
    // mock: true,
    control: 'dyc/zone/agreement/batchImportAgreementScope'
  },
  // 协议管理-查询当前选择的协议应用范围
  cnnc_qryAgreementScopes: {
    // mock: true,
    control: 'dyc/saas/common/agr/qryAgreementScopes'
  },
  // 协议管理-范围机构树全量查询
  cnnc_qryEnterpriseTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryEnterpriseTree'
  },
  // 协议管理-范围导入模板
  cnnc_qryImportTemplateDetail: {
    // mock: true,
    control: 'dyc/config/cfc/unite/qryImportTemplateDetail'
  },
  // 协议管理-协议维护-协议明细创建
  cnnc_createAgreementSku: {
    // mock: true,
    control: 'dyc/zone/agreement/createAgreementSku'
  },
  // 协议管理-协议维护-协议明细修改
  cnnc_modifyAgreementSku: {
    // mock: true,
    control: 'dyc/zone/agreement/batchModifyAgreementSku'
  },
  // 协议管理-协议维护-协议明细删除
  cnnc_deleteAgreementSku: {
    // mock: true,
    control: 'dyc/zone/agreement/deleteAgreementSku'
  },
  // 协议管理-协议维护-协议明细导入
  cnnc_dealAgrDetailedBatchImportAgreement: {
    // mock: true,
    control: 'dyc/zone/agreement/dealAgrDetailedBatchImportAgreement'
  },
  // 协议管理-协议维护-协议明细详情查询
  std_queryAgreementItemDetail: {
    // mock: true,
    control: 'dyc/zone/protocolmgnt/operator/agreementManage/queryAgreementItemDetail'
  },
  // 协议管理-协议维护-协议保存提交
  cnnc_submitAgreementInfo: {
    // mock: true,
    control: 'dyc/zone/agreement/submitAgreementInfo'
  },
  // 协议管理-协议维护-协议修改
  cnnc_modifyAgreementSubjectInfo: {
    // mock: true,
    control: 'dyc/zone/agreement/modifyAgreementSubjectInfo'
  },
  // 协议管理-协议维护-协议版本主体详情
  cnnc_qryAgreementSubjectDetailsVersion: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementSubjectDetailsVersion'
  },
  // 协议管理-协议维护-协议版本
  cnnc_qryAgreementChangeApplyByPageEdition: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementChangeApplyByPageEdition'
  },
  // 协议版本协议明细详情
  cnnc_qryAgreementSkuByPageVersion: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementSkuByPageVersion'
  },
  // 模板下载
  std_downloadAgreementAttachment: {
    // mock: true,
    control: '/dyc/zone/protocolmgnt/operator/agreementManage/downloadAgreementAttachment'
  },
  // 协议管理-协议变更-协议变更列表
  cnnc_qryAgreementChangeApplyByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementChangeApplyByPage'
  },
  // 协议管理-协议变更-协议变更删除操作
  cnnc_deleteAgreementChangeApply: {
    // mock: true,
    control: 'dyc/zone/agreement/deleteAgreementChangeApply'
  },
  // 协议管理-协议变更-协议变更新增
  cnnc_createAgreementChangeApply: {
    // mock: true,
    control: 'dyc/zone/agreement/createAgreementChangeApply'
  },
  // 协议管理-协议变更-协议变更申请号
  cnnc_getEncodedSerial: {
    // mock: true,
    control: 'dyc/zone/agreement/getEncodedSerial'
  },
  // 协议管理-协议变更-协议变更详情
  cnnc_qryAgreementMajorChangeDetail: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementMajorChangeDetail'
  },
  // 协议管理-协议变更-协议变更明细调价列表
  std_queryAgreementPriceChangeList: {
    // mock: true,
    control: '/dyc/zone/agreement/commoditymgnt/operator/commodityquery/queryAgreementPriceChangeList '
  },
  // 调价明细导入
  cnnc_importAgrPricingItem: {
    // mock: true,
    control: 'dyc/zone/agreement/old/importAgrPricingItem'
  },
  // 协议变更补充明细查询
  std_queryChangeAgreementListAbility: {
    // mock: true,
    control: 'dyc/zone/agreement/protocolmgnt/operator/protocolchange/queryAgreementItemList'
  },
  // 协议变更补充协明细新增-减少
  std_protocolChangeDetailAdd: {
    // mock: true,
    control: 'dyc/zone/agreement/protocolChangeDetailAdd'
  },
  // 协议变更减少协议明细弹框列表查询
  std_queryAgreementItemList: {
    // mock: true,
    control: 'dyc/zone/protocolmgnt/operator/agreementManage/queryAgreementItemList'
  },
  // 协议变更移除补充明细
  std_deleteAgreementSkuChange: {
    // mock: true,
    control: 'dyc/zone/agreement/protocolmgnt/operator/protocolchange/deleteAgreementSkuChange'
  },
  // 协议分配 查询 用户分配列表
  rest_alreadyUsers: {
    // mock: true,
    control: 'dyc/saas/common/user/getAlreadyUsers'
  },
  // 协议分配提交
  cnnc_assignAgreement: {
    // mock: true,
    control: 'dyc/zone/agreement/assignAgreement'
  },
  // 协议分配记录
  pesapp_queryAgreementDistRecordList: {
    // mock: true,
    control: 'dyc/zone/protocolmgnt/operator/agreementManage/queryAgreementDistRecordList'
  },
  // 协议新增审批列表
  cnnc_qryAgreementAddApprovalByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementAddApprovalByPage'
  },
  // 协议新增审批确认服务
  cnnc_approvalAgreementAdd: {
    // mock: true,
    control: 'dyc/zone/agreement/approvalAgreementAdd'
  },
  // 协议变更审批列表
  cnnc_qryAgreementChangeApplyApprovalByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementChangeApplyApprovalByPage'
  },
  // 协议变更审批确认服务
  cnnc_approvalAgreementChangeApply: {
    // mock: true,
    control: 'dyc/zone/agreement/approvalAgreementChangeApply'
  },
  // 协议变更审批-协议变更详情
  std_queryAgreementChangeDetail: {
    // mock: true,
    control: 'dyc/zone/agreement/protocolmgnt/operator/protocolchange/queryAgreementChangeDetail'
  },
  // 公共应用-单品下单搜索列表API
  dyc_getSkuOrdersearchList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuOrdersearchList'
  },
  // 选择计划明细服务
  dyc_getPpcPurchasePlanItemListQry: {
    // mock: true,
    control: 'dyc/saas/common/plan/qryPpcPurchasePlanItemList'
  },
  // 获取用户地址
  pesapp_queryReceiveAddress: {
    // mock: true,
    control: 'dyc/saas/common/getLogisticsRelaPage'
  },
  // 加入购物车
  cnnc_addShoppingCart: {
    // mock: true,
    control: 'dyc/saas/common/user/addShoppingCart'
  },
  // 商品清单列表查询
  dyc_getSpuListofItem: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuListofItem'
  },
  // 协议确认 协议新增待确认列表
  cnnc_qryAgreementInfoConfirmByPage: {
    // mock: true,
    control: 'dyc/zone/agreement/qryAgreementInfoConfirmByPage'
  },
  // 协议确认 协议新增确认服务
  cnnc_confirmFrameAgrList: {
    // mock: true,
    control: 'dyc/zone/agreement/confirmFrameAgrList'
  },
  // 协议确认 协议变更确认服务
  cnnc_confirmAgreementChangeApply: {
    // mock: true,
    control: 'dyc/zone/agreement/confirmAgreementChangeApply'
  },
  // 协议审批图
  std_queryFlowInformation: {
    // mock: true,
    control: 'dyc/zone/protocolmgnt/operator/agreementManage/queryFlowInformation'
  },
  // 协议审批图
  std_getSpuManagementListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSpuManagementListQry'
  },
  // 批量解绑协议下sku
  cnnc_batchCreateAgreementSku: {
    control: '/dyc/zone/agreement/batchCreateAgreementSku'
  },
  // 批量解绑协议下sku
  cnnc_batchDelAgrSkuInfo: {
    control: '/dyc/zone/agreement/batchDelAgrSkuInfo'
  },
  // 批量换绑Sku协议信息
  cnnc_batchModifyAgrSkuRelation: {
    control: '/dyc/zone/agreement/batchModifyAgreementSkuRelation'
  },
  // 协议关联商品-批量导出功能
  cnnc_skuSupplyInfoExport: {
    control: 'dyc/busicommon/commodity/skuAgreementExport'
  }
};